module.exports = __webpack_public_path__ + "63d984fd48cd675c93ee48fbef479a35.svg";